export default __webpack_public_path__ + "d91ede3e3d052aa5327ad43e57de4a95.svg";